import { FormGroup, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { countryCodes } from '../data/countries';
import * as XLSX from 'xlsx';

export class Utils {

  public static exportToExcel(data: any[], fileName: string = 'export.xlsx', sheetName: string = 'Sheet1') {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, fileName);
  }

  public static IsNull(obj: any) {
    return obj == null;
  }

  public static IsUndefined(obj: any) {
    return obj == undefined;
  }

  public static IsNullOrUndefined(obj: any) {
    return Utils.IsNull(obj) || Utils.IsUndefined(obj);
  }
  
  public static noPastDatesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // No value means no error
      }
  
      const selectedDate = new Date(control.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to start of the day
  
      return selectedDate < today ? { pastDate: true } : null;
    };
  }

  
  public static getBidStatusLabel(status: string | undefined): string {
    if (!status) return '';
  
    switch (status) {
      case 'Draft':
        return 'Open';
      case 'RejectedParticipation':
        return 'Rejected Participation';
      case 'PaymentVerificationPending':
        return 'Payment Verification Pending';
      default:
        return status; // Return as-is for other statuses
    }
  }
  

  public static IsWhiteSpace(obj: any) {
    let result = false;
    if (typeof obj !== 'string') {
      if (Utils.IsNullOrUndefined(obj)) {
        result = true;
      } else {
        result = false;
      }
    } else {
      if (Utils.IsNullOrUndefined(obj)) {
        result = true;
      } else {
        if (obj === '') {
          result = true;
        } else {
          result = false;
        }
      }
    }
    return result;
  }

  public static IsNullOrWhiteSpace(obj: any) {
    return Utils.IsNull(obj) || Utils.IsUndefined(obj) || Utils.IsWhiteSpace(obj) || obj === '';
  }

  // New utility method to check if a form control is required
  public static isControlRequired(control: AbstractControl | null): boolean {
    if (!control) return false;

    const validator = control.validator ? control.validator({} as AbstractControl) : null;
    return validator ? validator['required'] !== undefined : false;
  }

  // New utility method to append an asterisk to a label if required
  public static appendAsteriskToLabelIfRequired(labelElement: HTMLElement, control: AbstractControl | null): void {
    if (Utils.isControlRequired(control)) {
      labelElement.innerHTML += ' <span class="required">*</span>';
    }
  } 
}

export class GUID {
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
export class FormUtils {
  static  countryCodes = countryCodes;
  static  extractMobileDetails(fullMobile: string): { mobileCode: string, mobileNumber: string } {
    const countryCode = this.countryCodes.find(codeObj => fullMobile.startsWith(codeObj.code));
  
    if (countryCode) {
      const mobileNumber = fullMobile.replace(countryCode.code, ''); // Remove the country code from the full number
      return {
        mobileCode: countryCode.code,  // The country code (e.g., +974)
        mobileNumber: mobileNumber.trim()  // The remaining mobile number
      };
    }
  
    return {
      mobileCode: '',
      mobileNumber: fullMobile // Return the full number if no matching country code is found
    };
  }
  
  
    /**
     * Check if an element is visible in the DOM
     */
    private static isElementVisible(element: HTMLElement): boolean {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }
  
    /**
     * Validate form controls that are visible
     * @param formGroup - The FormGroup containing form controls
     * @returns boolean - True if all visible controls are valid, otherwise false
     */
    public static isVisibleFormValid(formGroup: FormGroup): boolean {
      let isValid = true;
  
      // Loop through each form control in the FormGroup
      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.get(key);
        const element = document.querySelector(`[formControlName="${key}"]`) as HTMLElement;
  
        if (control && element && FormUtils.isElementVisible(element)) {
          if (control.invalid) {
            isValid = false;
          }
        }
      });
  
      return isValid;
    }


     // for downloading attachments 




  }


  export class FileManagement {
    public static downloadFile(fileContent: string, fileName: string, mimeType?: string): void {
      try {
        let base64Data = fileContent;
    
        // If MIME type is not provided, try to extract it from the Base64 string
        if (!mimeType) {
          const base64HeaderMatch = fileContent.match(/^data:(.+);base64,(.+)$/);
          if (base64HeaderMatch && base64HeaderMatch.length === 3) {
            mimeType = base64HeaderMatch[1]; // Extract MIME type
            base64Data = base64HeaderMatch[2]; // Extract Base64 data
          } else if (fileContent.includes(',')) {
            base64Data = fileContent.split(',')[1]; // Extract Base64 data without MIME type
          }
        }
    
        // Infer MIME type from file name if still not provided
        if (!mimeType && fileName.includes('.')) {
          const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
          mimeType = this.getMimeTypeFromExtension(extension) || 'application/octet-stream'; // Default MIME type
        }
    
        const byteCharacters = atob(base64Data); // Decode Base64
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0)); // Convert to byte array
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType }); // Create a Blob with the correct MIME type
    
        const link = document.createElement('a'); // Create a temporary anchor element
        const fileURL = URL.createObjectURL(blob); // Create a URL for the Blob
    
        link.href = fileURL;
        link.download = fileName; // Set the download attribute with the desired file name
        link.click(); // Trigger the download
    
        URL.revokeObjectURL(fileURL); // Clean up the URL object
      } catch (e) {
        console.error('Error processing the Base64 string for download:', e);
      }
    }
    
    // Helper method to infer MIME type from file extension
    private static getMimeTypeFromExtension(extension: string): string | undefined {
      const mimeTypes: { [key: string]: string } = {
        'pdf': 'application/pdf',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'gif': 'image/gif',
        'txt': 'text/plain',
        'csv': 'text/csv',
        'html': 'text/html',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'ppt': 'application/vnd.ms-powerpoint',
        'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'zip': 'application/zip',
        'mp4': 'video/mp4',
        'mp3': 'audio/mpeg',
        // Add more as needed
      };
      return mimeTypes[extension];
    }
    
  }
  


  

